export const showToast = (txt) => {
    let createToast = document.createElement('div');
    createToast.style.cssText = `
        background:rgba(0,0,0,.7);
        position:fixed;
        left:50%;
        top:40%;
        transform :translateX(-50%);
        border-radius:.2rem;
        font-size:.32rem;
        color:#fff;
        z-index:200;
        padding:.32rem 0.5rem;
    `
    createToast.innerHTML = txt;
    document.body.appendChild(createToast);
    setTimeout( () => createToast.remove(),2000 )
}